import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Image({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Image.Outline {...props} /> : <Image.Solid {...props} />;
}

Image.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.26099 8.78496C6.26099 7.35049 7.42404 6.18896 8.85699 6.18896C10.2896 6.19037 11.4516 7.35159 11.453 8.78423C11.453 10.2184 10.2912 11.381 8.85699 11.381C7.42404 11.381 6.26099 10.2194 6.26099 8.78496ZM8.85662 7.68896C8.25173 7.68916 7.76099 8.17957 7.76099 8.78496C7.76099 9.39049 8.25194 9.88096 8.85699 9.88096C9.46267 9.88096 9.95283 9.39091 9.95299 8.78526C9.95216 8.18022 9.46166 7.68976 8.85662 7.68896Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.52201 3.68301C4.52707 2.60423 5.95882 1.99976 7.65076 1.99976H16.3028C17.9995 1.99976 19.4325 2.60378 20.437 3.68337C21.4359 4.75695 21.955 6.23965 21.9528 7.90475V16.0498C21.9528 17.7145 21.4329 19.1969 20.4336 20.2703C19.4286 21.3498 17.9954 21.9538 16.2978 21.9538H7.65076C5.95525 21.9538 4.52314 21.3496 3.51871 20.2702C2.51993 19.1969 1.99976 17.7146 1.99976 16.0498V7.90376C1.99976 6.2381 2.52242 4.7559 3.52201 3.68301ZM4.6195 4.70551C3.92159 5.45461 3.49976 6.54941 3.49976 7.90376V16.0498C3.49976 16.7921 3.62587 17.4562 3.85444 18.0282C4.37977 17.209 5.08114 16.2845 5.86693 15.5609C6.40637 15.0642 7.02912 14.6213 7.70219 14.3989C8.40001 14.1684 9.16486 14.1744 9.88585 14.607C11.1205 15.3478 11.7187 15.5001 11.9999 15.5001C12.1702 15.5 12.2275 15.4618 12.4696 15.2197C12.6818 15.0075 13.1463 14.429 13.6643 13.7815L13.7046 13.7311C14.1759 13.142 14.6898 12.4995 14.9696 12.2197L14.9782 12.2112C15.2509 11.9383 15.9388 11.25 17.125 11.25C18.0509 11.25 19.1418 11.6671 20.4528 12.7381V7.90376C20.4545 6.54886 20.0352 5.45356 19.3388 4.70514C18.648 3.96273 17.629 3.49976 16.3028 3.49976H7.65076C6.3307 3.49976 5.31194 3.96228 4.6195 4.70551ZM20.4528 14.7635C18.7678 13.0833 17.7043 12.75 17.125 12.75C16.5737 12.75 16.2635 13.0471 16.0303 13.2803C15.8182 13.4925 15.3536 14.071 14.8356 14.7185L14.7953 14.7689C14.3241 15.358 13.8102 16.0005 13.5303 16.2803L13.5132 16.2974C13.253 16.558 12.8118 17 12 17.0001C11.2812 17.0001 10.3794 16.6524 9.1141 15.8932C8.83509 15.7258 8.53743 15.7027 8.17276 15.8232C7.78333 15.9519 7.34358 16.2402 6.88302 16.6643C6.03355 17.4466 5.26114 18.5519 4.77237 19.4055C5.45724 20.0557 6.42235 20.4538 7.65076 20.4538H16.2978C17.6251 20.4538 18.6444 19.9907 19.3357 19.2482C20.0326 18.4996 20.4528 17.405 20.4528 16.0498V14.7635Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Image.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
